import { useState } from 'react'
import { RedemptionError, redeemOrderCode } from './redeemOrderCode'
import type {
  RedemptionErrorCode,
  RedemptionResult
} from './OrderCodeForm.types'

export const ERROR_MESSAGES: Record<RedemptionErrorCode, string> = {
  order_not_found:
    'Ainda não encontramos esse pedido. Ele pode levar algumas horas para chegar até nós depois da compra. Confira o código e tente de novo mais tarde.',
  order_used_up:
    'Esse código já liberou o acesso de todos os alunos do pedido. Se isso não parece certo, fale com a gente em atendimento@arvore.com.br.',
  order_other_school:
    'Esse pedido é de outra escola. Confira se você entrou com a sua conta ou fale com a gente em atendimento@arvore.com.br.',
  student_not_in_school:
    'Sua conta ainda não está em uma turma da escola. Peça para a escola colocar você na turma e tente de novo.',
  order_without_school:
    'Não conseguimos ligar esse pedido a uma escola. Peça para quem fez a compra abrir o link do e-mail da compra.',
  order_name_mismatch:
    'Recebemos o seu código. Esse pedido tem mais de um aluno, então o nosso time vai conferir e avisar a sua família por e-mail quando o acesso estiver liberado.',
  too_many_attempts:
    'Foram muitas tentativas seguidas. Espere um minuto e tente de novo.',
  unexpected_error:
    'Não conseguimos liberar agora. Tente de novo em alguns minutos.'
}

const NOTICE_CODES: RedemptionErrorCode[] = ['order_name_mismatch']

export const useOrderCodeForm = (
  onRedeemed: (result: RedemptionResult) => void
) => {
  const [code, setCode] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorCode, setErrorCode] = useState<RedemptionErrorCode | null>(null)

  const handleCodeChange = (value: string) => {
    setCode(value.toUpperCase())
    setErrorCode(null)
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!code.trim() || isSubmitting) return

    setIsSubmitting(true)
    setErrorCode(null)

    try {
      const result = await redeemOrderCode(code)
      onRedeemed(result)
    } catch (error) {
      setErrorCode(
        error instanceof RedemptionError ? error.code : 'unexpected_error'
      )
      setIsSubmitting(false)
    }
  }

  return {
    code,
    isSubmitting,
    errorMessage:
      errorCode && !NOTICE_CODES.includes(errorCode)
        ? ERROR_MESSAGES[errorCode]
        : null,
    noticeMessage:
      errorCode && NOTICE_CODES.includes(errorCode)
        ? ERROR_MESSAGES[errorCode]
        : null,
    canSubmit: Boolean(code.trim()) && !isSubmitting,
    handleCodeChange,
    handleSubmit
  }
}
